/**
 * Client helpers for /api/key-metrics.
 */

export async function fetchKeyMetrics({ website, recompute = false, getToken }) {
  if (!website) throw new Error('website is required');
  const params = new URLSearchParams({ website: String(website) });
  if (recompute) params.set('recompute', '1');

  const headers = {};
  if (typeof getToken === 'function') {
    try {
      const token = await getToken();
      if (token) headers.Authorization = `Bearer ${token}`;
    } catch {
      /* public ok */
    }
  }

  const res = await fetch(`/api/key-metrics?${params}`, { headers });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Key metrics request failed (${res.status})`);
  }
  return res.json();
}

export async function patchKeyMetrics({ website, patch, getToken, recompute = false }) {
  if (!website) throw new Error('website is required');
  const headers = { 'Content-Type': 'application/json' };
  if (typeof getToken === 'function') {
    try {
      const token = await getToken();
      if (token) headers.Authorization = `Bearer ${token}`;
    } catch {
      /* public ok */
    }
  }

  const res = await fetch('/api/key-metrics', {
    method: 'POST',
    headers,
    body: JSON.stringify({ website, patch, recompute }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Key metrics patch failed (${res.status})`);
  }
  return res.json();
}

/** Fire-and-forget cache write (does not throw to callers). */
export function softPatchKeyMetrics(args) {
  patchKeyMetrics(args).catch((err) => {
    if (typeof console !== 'undefined') {
      console.warn('[key-metrics] soft patch failed:', err?.message || err);
    }
  });
}
